import React from "react";
import {
  Collapse,
  createMuiTheme,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  ThemeProvider,
  SwipeableDrawer,
} from "@material-ui/core";
import { ExpandMore, NavigateNext } from "@material-ui/icons";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import clsx from "clsx";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import * as authRedux from "../../../app/modules/Auth/_redux/authRedux";
import * as crmConstants from "../../../app/modules/CRM/constants";
import * as c2cConstants from "../../../app/modules/Ticker/constants";
import * as helpers from "../../../app/util/helpers";
import {
  UserProfileImageWithStatus,
  UserStatusDropdown,
} from "../../../Utils/layout/components/extras/dropdowns/UserProfileDropdown";
import { checkIsActive, toAbsoluteUrl } from "../../../Utils/_helpers";
import { resetCRM } from "../../modules/CRM/CRMFilters";
import { setLiveInteractionPageTabIndex } from "../../modules/LiveInteractions/state/slices/liveInteractionsSlice";
import { GetCallProgess } from "../../modules/Ticker/GetCallProgress";
import { PhoneSelect } from "../../modules/Ticker/PhoneSelect";
import { Timer } from "../../modules/Ticker/Timer";
import { Tracker } from "../../util/analytics";
import { Loader2 } from "../../util/loading";
import { useMobileViewport } from "../../util/mobileViewPort";
import { TextWrap } from "../../util/showmore";
import { setToastInfoForAccountStatus, updateUserStatus } from "../../modules/Auth/_redux/userProfileSlice";
import { actions } from "../../modules/Dashboard/_redux/dashboardRedux";
import ConfigurationToastMessage from "../../modules/Configuration/pages/Configuration/Util/ConfigurationToastMessage";
import { openCallPopup } from '../../modules/WhatsappCall/callPopupSlice';

const drawerWidth = 265;

const theme = createMuiTheme({
  breakpoints: {
    values: {
      custom: 991
    }
  }
})

const useStyles = makeStyles((theme) => ({
  drawer: {
    position: "fixed",
    whiteSpace: "nowrap",
    background: "#2c3687",
    color: "white",
    overflow: "overlay",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: 340,
    }),
    zIndex: 99999,
    [theme.breakpoints.down(991)]: {
      width: "100%",
      marginTop: "56px",
      maxHeight: "calc(100% - 60px)",
    },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: 340,
    }),
    overflowX: "hidden",
    width: theme.spacing(13),
  },

  menuLabel: {
    flexFlow: (props) => !props.openMenu && "column",
    [theme.breakpoints.down(991)]: {
      flexFlow: "row !important",
    },
  },

  listItemText: {
    marginLeft: (props) => props.openMenu && "20px",
    [theme.breakpoints.down(991)]: {
      marginLeft: "20px !important",
    },
  },

  ctcBtn: {
    border: "2px solid #40b783",
    marginLeft: 25,
    justifyContent: "space-between",
    borderRadius: "30px",
    padding: "4px",
    fontSize: 16,
    fontWeight: 800,
    color: "#40b783",
    cursor: "pointer",
    width: "82%",
  },

  oldVersionLabel: {
    fontWeight: 400,
    fontSize: 14,
    opacity: 0.7,
    marginLeft: 20,
    color: "#fff",
    "&:hover": {
      color: "#fff",
    },
  },

  highLightSingleMenu: {
    "&:hover": {
      color: "#fff",
      opacity: "0.5 !important",
      background: "#1b1b28 !important",
    },
    [theme.breakpoints.down("lg")]: {
      "&:focus": {
        opacity: "1 !important",
      },
      "&:active": {
        opacity: "1 !important",
      },
    },
  },

  noHighLightParentMenu: {
    "&:hover": {
      color: "#fff !important",
      opacity: "0.5 !important",
      background: "none !important",
    },
  },

  highLightChildMenu: {
    "&:hover": {
      backgroundColor : 'unset',
      color: "#fff !important",
      opacity: "1 !important",
    },
  },

  menu: {
    color: "#fff",
    opacity: (props) => props.isSuspendedAccount ? 0.1 : 0.5,
    pointerEvents: (props) => props.isSuspendedAccount && 'none',
    fontSize: 12,
    textAlign: (props) => !props.openMenu ? "left": "center",
    "&.Mui-selected": {
      background: "none",
      opacity: 1,
      "&:hover": {
        background: "none !important",
        color: "#fff !important",
        opacity: "1 !important",
      },
    },
    "&:hover": {
      // color: "#fff",
      // opacity: 1,
      // background: "none",
    },
    justifyContent: (props) => !props.openMenu && "center",
    [theme.breakpoints.down(991)]: {
      paddingLeft: "3.25rem",
    },
  },

  accMenu: {
    color: "#fff",
    opacity: 0.5,
    fontSize: 12,
    textAlign: "center",
    "&.Mui-selected": {
      background: "none",
      opacity: 1,
      "&:hover": {
        background: "none !important",
        color: "#fff !important",
        opacity: "1 !important",
      },
    },
    justifyContent: (props) => !props.openMenu && "center",
    [theme.breakpoints.down(991)]: {
      paddingLeft: "3.25rem",
    },
  },

  ongGoingCall: {
    width: "60%",
    flexDirection: "row !important",
    alignItems: "center",
    justifyContent: "space-between",
  },

  scrollBar: {
    background: "#637009",
    opacity: 1,
  },

  ctcLogo: {
    marginRight: "32px",
  },
  ctcwhatsappLogo: {
    marginRight: "10px",
  },
  disabledText: {
    color: 'grey',
    cursor: 'inherit',
    '&:hover': {
      color: 'grey !important',
    },
  },
  
}));
const AsideMenu = ({ openMobileAsideMenu, handleMobileAsideMenu }) => {
  const [openMenu, setOpenMenu] = useState(false);
 
  useEffect(() => {
    setOpenMenu(openMobileAsideMenu);
  }, [openMobileAsideMenu]);

  let assumeId = localStorage.getItem("assume_id");
   assumeId = (assumeId === 'null' || assumeId === '' || assumeId === 'None') ? false : assumeId;
  const dispatch = useDispatch();

  const { extra_data } = useSelector(({ auth }) => ({
    extra_data: auth.extra_data,
  }));

  const isDuplicatedTab = useSelector(state => state.auth.is_duplicated_tab);

  const { user } = useSelector((state) => state.auth);

  const [onGoingCall, setOnGoingCall] = useState(false);
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [isMenuExpandedCampaign, setIsMenuExpandedCampaign] = useState(false);
  const [isMenuExpandedInsights, setisMenuExpandedInsights] = useState(false);
  const [isMenuExpandedAccount, setIsMenuExpandedAccount] = useState(false);
  const [expandSettingMenu, setExpandSettingMenu] = useState(false);
  const [expandConfigMenu, setExpandConfigMenu] = useState(false);
  const [expandDeveloperMenu, setExpandDeveloperMenu] = useState(false);

  const call_state = useSelector((state) => {
    return state.ticker.call_state;
  });

  const { statusToastInfo } = useSelector((state) => state.userProfileSlice);

  useEffect(() => {
    if (call_state === "CALL_CONNECTED") {
      setOnGoingCall(true);
    } else {
      setOnGoingCall(false);
    }
  }, [call_state]);

  const classes = useStyles({ openMenu, isSuspendedAccount: helpers.isFeatureEnabledProfile('is_suspended_account') });

  const handleDrawerOnMenuSelect = () => {
    // setOpenMenu(false);
    if (isMobileView) handleMobileAsideMenu();
  };

  const handleDrawerSwipeProps = (value) => {
    setOpenMenu(value);
  };

  const handleMenuExpandCollapse = (e) => {
    e.preventDefault();
    setIsMenuExpanded((prev) => !prev);
  };

  const handleMenuExpandCollapseCampaign = (e) => {
    e.preventDefault();
    setIsMenuExpandedCampaign((prev) => !prev);
  };

  const handleMenuExpandedInsights = (e) => {
    e.preventDefault();
    setisMenuExpandedInsights((prev) => !prev);
  };

  const handleMenuExpandCollapseAccount = (e) => {
    e.preventDefault();
    setIsMenuExpandedAccount((prev) => !prev);
  };

  const handleConfigMenuExpandCollapse = (e) => {
    e.preventDefault();
    setExpandConfigMenu((prev) => !prev);
  };

  const handleSettingMenuExpandCollapse = (e) => {
    e.preventDefault();
    setExpandSettingMenu((prev) => !prev);
  };

  const handleDeveloperMenuExpandCollapse = (e) => {
    e.preventDefault();
    setExpandDeveloperMenu((prev) => !prev);
  };

  const swipeableDrawerProps = {
    onMouseEnter: () => handleDrawerSwipeProps(true),
    onMouseLeave: () => handleDrawerSwipeProps(false),
    onOpen: () => handleDrawerSwipeProps(true),
    onClose: () => handleDrawerSwipeProps(false),
    classes: {
      paper: clsx(classes.drawer, {
        [classes.drawerOpen]: true,
        [classes.drawerClose]: !openMenu,
        "aside-menu-mui": !openMenu,
        "aside-menu-mui-sroll": openMenu
      }),
    },
  };

  const location = useLocation();
  const history = useHistory();
  const isMobileView = useMobileViewport();

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const clearFilters = () => {
    dispatch({ type: "ClearMainFilters", payload: {} });
  };

  const loadingState = (resource, status) => {
    dispatch(
      actions.setLoadingState({
        resource: resource,
        loading_state: status,
      })
    );
  };

  const handleCloseSnackbar = () => {
    dispatch(closeSnackbar());
  };

  const closeSnackbar = () => {
    return setToastInfoForAccountStatus({
      open: false,
      snackbarMessage: "",
      severity: "",
    });
  };
  const handleOpenCallPopup = () => {
    dispatch(openCallPopup());
  };

  const handleUserStatus = () => {
    if(helpers.isCallCenterEnabled()){
    const logoutStatus = {
      label: "Logged Out",
      value: "Logged Out",
    };
    dispatch(
      updateUserStatus({
        selectedStatus: logoutStatus,
        userId: user.user_id,
      })
    ).then((res) => {
      if (res.error) {
        dispatch(
          setToastInfoForAccountStatus({
            open: true,
            snackbarMessage: "Status update failed",
            severity: "error",
          })
        );
      } else {
        dispatch(
          setToastInfoForAccountStatus({
            open: true,
            snackbarMessage: "Status updated successfully",
            severity: "success",
          })
        );
      }
    });}
    try {
      if(process.env.REACT_APP_ENV == 'dev') {
        setTimeout(() => { window.location = "/logout"; }, 10);
        return;
      };
      helpers.authLogoutSession(dispatch, helpers.logoutCallback);
    } catch (e) {
      loadingState("iframe_logout", "loaded");
      setTimeout(() => { window.location.href = process.env.REACT_APP_IFRAME_BASE_URL; }, 10);
    }
  };

  const renderMenus = () => (
    <div className="w-100">
      {!isMobileView && (
        <>
          <div
            className={`d-flex align-items-center mt-11 mb-6 ${clsx({
              "justify-content-start ml-8": openMenu,
              " justify-content-center ": !openMenu,
            })}`}
          >
            <span className="brand-menu-logo d-flex justify-content-center">
              <img
                alt="logo"
                src={toAbsoluteUrl("/media/sr/logos/menu-brand-logo.svg")}
              />
              {helpers.isFeatureEnabledProfile('remove_konnect_dependency') && <span style={{ fontSize: 7, color: "white" }}>&#9733;</span>}
              {openMenu && (
                // <a
                //   href="javascript:void(0)"
                //   className={classes.oldVersionLabel}
                // >
                  <div className={`d-flex flex-column justify-content-center ml-4 mt-2 ${classes.oldVersionLabel}`}>
                    <span style={{ fontWeight: 400, fontSize: 16, lineHeight: '12px' }}>Super</span>
                    <span style={{ fontWeight: 700, fontSize: 16 }}>Receptionist</span>
                  </div>
                // </a>
              )}
            </span>
          </div>

          <div
            className={`d-flex align-items-center  ${clsx({
              "justify-content-start mt-6 mb-3": openMenu,
              "justify-content-center mt-10 mb-6": !openMenu,
            })}`}
          >
            {helpers.isFeatureEnabledProfile('is_whatsapp_voice_enabled') && (
               <div className="w-100">
           
                  <div
                    className={`d-none d-lg-flex align-items-center justify-content-center ${clsx(
                      {
                        [classes.ctcBtn]: openMenu,
                      }
                    )}`}
                    onClick={() => {
                      if(isDuplicatedTab) {
                        dispatch(
                          setToastInfoForAccountStatus({
                            open: true,
                            snackbarMessage: "Please initiate whatsapp calling request from the Primary SR tab.",
                            severity: "warning",
                          })
                        );
                        return;
                      }
                      handleOpenCallPopup()
                    }}
                  >
                    <div
                      className={clsx({
                        [classes.ctcwhatsappLogo]: openMenu,
                      })}
                    >
                      <span className="ctc-btn-logo">
                        <img
                          style={{height:"55px",width:"55px"}}
                          alt="logo"
                          src={toAbsoluteUrl("/media/sr/icons/whatsapp-call-icon.png")}
                        />
                      </span>
                      {openMenu && (
                        <span className="ml-3 ctc-btn-label">
                          WhatsApp Call
                        </span>
                      )}
                    </div>
                  </div>
              </div>
            )}
            {extra_data && extra_data.is_new_live_ticker_enabled && !helpers.isFeatureEnabledProfile('is_whatsapp_voice_enabled') && (
              <div className="w-100">
                {onGoingCall ? (
                  <div
                    className="aside-menu-ongoing-icon d-none d-lg-flex"
                    to=""
                  >
                    <span className="ctc-btn-sec d-block">
                      <span
                        className={`ongoing-call-opt ${clsx({
                          [classes.ongGoingCall]: openMenu,
                          "ml-n12": openMenu,
                        })}`}
                      >
                        <span className="ctc-btn-ongoing-logo">
                          <img
                            alt="logo"
                            src={toAbsoluteUrl(
                              "/media/sr/icons/direct-call.svg"
                            )}
                          />
                        </span>
                        <span
                          className={`ongoing-detail  ${clsx({
                            "ml-12": openMenu,
                          })}`}
                        >
                          <div className="ongoing-title">
                            <GetCallProgess />
                          </div>
                          <div className="ongoing-time">
                            {" "}
                            <Timer disableSymbols={true} />
                          </div>
                        </span>
                      </span>
                    </span>
                  </div>
                ) : (
                  <div
                    className={`d-none d-lg-flex align-items-center justify-content-center ${clsx(
                      {
                        [classes.ctcBtn]: openMenu,
                      }
                    )}`}
                    onClick={() => {
                      if(isDuplicatedTab) {
                        dispatch(
                          setToastInfoForAccountStatus({
                            open: true,
                            snackbarMessage: "Please initiate C2C request from the Primary SR tab.",
                            severity: "warning",
                          })
                        );
                        return;
                      }
                      dispatch({ type: "Open", payload: {} });

                      Tracker.event(
                        c2cConstants.ANALYTICS.C2CWidgetClick_LEFT_NAV[0],
                        c2cConstants.ANALYTICS.C2CWidgetClick_LEFT_NAV[1],
                        c2cConstants.ANALYTICS.C2CWidgetClick_LEFT_NAV[2],
                        c2cConstants.ANALYTICS.C2CWidgetClick_LEFT_NAV[3],
                        helpers.getUser()
                      );
                    }}
                  >
                    <div
                      className={clsx({
                        [classes.ctcLogo]: openMenu,
                      })}
                    >
                      <span className="ctc-btn-logo">
                        <img
                          alt="logo"
                          src={toAbsoluteUrl("/media/sr/icons/direct-call.svg")}
                        />
                      </span>
                      {openMenu && (
                        <span className="ml-6 ctc-btn-label">
                          Click to Call
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}

      <List component="div">
      <ListItem
          component={Link}
          className={`${classes.accMenu} ${classes.highLightSingleMenu} ${clsx(
            {
              "justify-content-center flex-grow-1": !openMenu,
              "justify-content-start": openMenu
            }
          )}`}
          onClick={() => {
            Tracker.event(
              "NAV",
              "left-nav",
              "Home Clicked",
              "Home-clicked",
              helpers.getUser()
            );
            clearFilters();
            handleDrawerOnMenuSelect(false);
          }}
          selected={getMenuItemActive("/home", false)}
          to="/home"
        >
          <div
            className={`d-flex align-items-center justify-content-center ${classes.menuLabel} `}
          >
            <SVG src={toAbsoluteUrl("/media/sr/icons/homenew.svg")} />
            <ListItemText className={classes.listItemText}>
              Home
            </ListItemText>
          </div>
        </ListItem>
        
        {/* Dashboard */}
        <ListItem
          component={Link}
          className={`${classes.menu} ${classes.highLightSingleMenu} ${clsx(
            {
              "justify-content-center flex-grow-1": !openMenu,
              "justify-content-start": openMenu
            }
          )}`}
          onClick={() => {
            Tracker.event(
              "NAV",
              "left-nav",
              "Dashboard Clicked",
              "dashboard-clicked",
              helpers.getUser()
            );
            clearFilters();
            handleDrawerOnMenuSelect(false);
          }}
          selected={getMenuItemActive("/dashboard", false)}
          to="/dashboard"
        >
          <div
            className={`d-flex align-items-center justify-content-center ${classes.menuLabel} `}
          >
            <SVG src={toAbsoluteUrl("/media/sr/icons/dashboard-icon.svg")} />
            <ListItemText className={classes.listItemText}>
              Dashboard
            </ListItemText>
          </div>
        </ListItem>

        {/* Insights */}
        {!helpers.isAgent() && 
        !helpers.isFeatureEnabledProfile('is_cuberon_activated') &&  (
          <ListItem
            component={Link}
            className={`${classes.menu} ${classes.highLightSingleMenu} ${clsx(
              {
                "justify-content-center flex-grow-1": !openMenu,
                "justify-content-start": openMenu
              }
            )}`}
            onClick={() => {
              Tracker.event(
                "NAV",
                "left-nav",
                "Insights Clicked",
                "insights-clicked",
                helpers.getUser()
              );
              clearFilters();
              handleDrawerOnMenuSelect(false);
            }}
            selected={getMenuItemActive("/insights", false)}
            to="/insights"
          >
            <div
              className={`d-flex align-items-center justify-content-center ${classes.menuLabel} `}
            >
              <SVG src={toAbsoluteUrl("/media/sr/icons/insights-icon.svg")} />
              <ListItemText className={classes.listItemText}>
                Insights
              </ListItemText>
            </div>
          </ListItem>
        )}

        {/* Insights - Custom Insights */}
        {!helpers.isAgent() &&
          helpers.isFeatureEnabledProfile('is_cuberon_activated') &&
          <>
            <ListItem
              component={Link}
              className={`${classes.noHighLightParentMenu} ${clsx(
                classes.menu,
                {
                  "justify-content-center flex-grow-1": !openMenu,
                  "justify-content-start": openMenu
                }
              )}`}
              selected={getMenuItemActive("/insights", false)}
              onClick={(e) => handleMenuExpandedInsights(e)}
            >
              <div
                className={`d-flex align-items-center justify-content-center ${classes.menuLabel} flex-grow-1`}
              >
                <SVG src={toAbsoluteUrl("/media/sr/icons/insights-icon.svg")} />
                <div className="d-flex justify-content-between flex-grow-1">
                  <ListItemText className={classes.listItemText} style={{display: "flex"}}>
                    Insights
                  </ListItemText>
                  {openMenu && (
                    <div>
                      {isMenuExpandedInsights ? <ExpandMore /> : <NavigateNext />}
                    </div>
                  )}
                </div>
              </div>
            </ListItem>

            {openMenu && (
              <Collapse in={isMenuExpandedInsights} timeout="auto" unmountOnExit>
                <div className="ml-10">
                  <ListItem
                    component={Link}
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.menu,
                      {
                        "justify-content-center": !openMenu,
                        "justify-content-start": openMenu
                      }
                    )}`}
                    onClick={() => {
                      if(checkIsActive(location, "insights")) return;
                      Tracker.event(
                        "Basic Insights",
                        "Click",
                        "Basic Insights Click",
                        "Basic Insights Click Left Nav",
                        helpers.getUser()
                      );
                      clearFilters();
                      handleDrawerOnMenuSelect(false);
                    }}
                    selected={getMenuItemActive("insights", false)}
                    to="/insights"
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        Basic Insights
                      </ListItemText>
                    </div>
                  </ListItem>
                  <ListItem
                    target="_blank"
                    button 
                    component="a"
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.menu,
                      {
                        "justify-content-center": !openMenu,
                      }
                    )}`}
                    onClick={() => {
                      Tracker.event(
                        "Custom Insights",
                        "Click",
                        "Custom Insights Click",
                        "Custom Insights Click Left Nav",
                        helpers.getUser()
                      );
                      handleDrawerOnMenuSelect(false);
                    }}
                    href={process.env.REACT_APP_IFRAME_BASE_URL + 'newsr/custom_charts_view/'}
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        Custom Insights
                      </ListItemText>
                    </div>
                  </ListItem>
                </div>
              </Collapse>
            )}
          </>}

        {/* Live Interactions - For Admin/Supervisor */}
        {!helpers.isAgent() &&
        !helpers.isFeatureEnabledProfile('is_suspended_account') &&
          extra_data && (extra_data.is_call_monitor === 1 ||
            extra_data.is_queue_monitor === 1) &&
          helpers.isCallCenterEnabled() && (
            <ListItem
              component={Link}
              className={`${classes.highLightSingleMenu} ${clsx(classes.menu, {
                "justify-content-center": !openMenu,
                "justify-content-start": openMenu
              })}`}
              onClick={() => {
                Tracker.event(
                  "NAV",
                  "left-nav",
                  "Live-Interactions Clicked",
                  "live-interactions-clicked",
                  helpers.getUser()
                );
                clearFilters();
                dispatch(setLiveInteractionPageTabIndex(0));
                setTimeout(() => {
                  history.push("/live-interactions/call-monitor");
                }, 0);
                handleDrawerOnMenuSelect(false);
              }}
              to="/live-interactions"
              selected={getMenuItemActive("/live-interactions", false)}
            >
              <div
                className={`d-flex align-items-center justify-content-center ${classes.menuLabel} `}
              >
                <SVG src={toAbsoluteUrl("/media/sr/icons/calls-icon.svg")} />
                <ListItemText
                  style={{ whiteSpace: "pre-line" , textAlign: 'center'}}
                  className={classes.listItemText}
                >
                  Live Interactions
                </ListItemText>
              </div>
            </ListItem>
          )}

        {/* Queue Monitoring - For Agents */}
        {helpers.isAgent() &&
          helpers.isFeatureEnabled("queue_monitoring") &&
          !helpers.isFeatureEnabledProfile('is_suspended_account') &&
          helpers.isCallCenterEnabled() && (
            <ListItem
              component={Link}
              className={`${classes.highLightSingleMenu} ${clsx(classes.menu, {
                "justify-content-center": !openMenu,
                "justify-content-start": openMenu
              })}`}
              onClick={() => {
                Tracker.event(
                  "NAV",
                  "left-nav",
                  "Live-Interactions Clicked",
                  "live-interactions-clicked",
                  helpers.getUser()
                );
                clearFilters();
                handleDrawerOnMenuSelect(false);
              }}
              to="/live-interactions/queues-monitor"
              selected={getMenuItemActive(
                "/live-interactions/queues-monitor",
                false
              )}
            >
              <div
                className={`d-flex align-items-center justify-content-center ${classes.menuLabel} `}
              >
                <SVG src={toAbsoluteUrl("/media/sr/icons/calls-icon.svg")} />
                <ListItemText
                  style={{ whiteSpace: "pre-line" , textAlign: 'center'}}
                  className={classes.listItemText}
                >
                  Live Interactions
                </ListItemText>
              </div>
            </ListItem>
          )}

        {/* Logs */}
        {(helpers.isFeatureEnabled("sms_logs") ||
          helpers.isFeatureEnabled("call_logs-removed")) && (
          <>
            <ListItem
              component={Link}
              className={`${classes.noHighLightParentMenu} ${clsx(
                classes.menu,
                {
                  "justify-content-center flex-grow-1": !openMenu,
                  "text-left": openMenu,
                }
              )}`}
              selected={
                getMenuItemActive("/smslogs", false) ||
                getMenuItemActive("/call-logs", false)
              }
              onClick={(e) => handleMenuExpandCollapse(e)}
            >
              <div
                className={`d-flex align-items-center justify-content-center ${classes.menuLabel} flex-grow-1`}
              >
                <SVG src={toAbsoluteUrl("/media/sr/icons/logs.svg")} />
                <div className="d-flex justify-content-between flex-grow-1">
                  <ListItemText className={classes.listItemText}>
                    Logs
                  </ListItemText>
                  {openMenu && (
                    <div>
                      {isMenuExpanded ? <ExpandMore /> : <NavigateNext />}
                    </div>
                  )}
                </div>
              </div>
            </ListItem>

            {openMenu && (
              <Collapse in={isMenuExpanded} timeout="auto" unmountOnExit>
                <div className="ml-10">
                  {helpers.isFeatureEnabled("call_logs") && (
                    <ListItem
                      component={Link}
                      className={`${classes.highLightChildMenu} ${clsx(
                        classes.menu,
                        {
                          "justify-content-center": !openMenu,
                          "justify-content-start": openMenu
                        }
                      )}`}
                      onClick={() => {
                        Tracker.event(
                          "Call Logs",
                          "Click",
                          "Call Logs Click",
                          "Call Logs Click Left Nav",
                          helpers.getUser()
                        );
                        clearFilters();
                        handleDrawerOnMenuSelect(false);
                      }}
                      selected={getMenuItemActive("call-logs", false)}
                      to="/call-logs"
                    >
                      <div>
                        <ListItemText className={classes.listItemText}>
                          Call Logs
                        </ListItemText>
                      </div>
                    </ListItem>
                  )}
                  {helpers.isSMSLogsEnabled() &&
                    helpers.isFeatureEnabled("sms_logs") && helpers.isFeatureEnabledProfile("is_sms_enabled") && (
                      <ListItem
                        component={Link}
                        className={`${classes.highLightChildMenu} ${clsx(
                          classes.menu,
                          {
                            "justify-content-center": !openMenu,
                          }
                        )}`}
                        selected={getMenuItemActive("smslogs", false)}
                        onClick={() => {
                          Tracker.event(
                            "SMS Logs",
                            "Click",
                            "SMS Logs Click",
                            "SMS Logs Click Left Nav",
                            helpers.getUser()
                          );
                          clearFilters();
                          handleDrawerOnMenuSelect(false);
                        }}
                        to="/smslogs"
                      >
                        <div className="d-flex">
                          <ListItemText className={classes.listItemText}>
                            SMS Logs
                          </ListItemText>
                        </div>
                      </ListItem>
                    )}
                   {helpers.isFeatureEnabledProfile('is_whatsapp_voice_enabled') &&
                      <ListItem
                        component={Link}
                        className={`${classes.highLightChildMenu} ${clsx(
                          classes.menu,
                          {
                            "justify-content-center": !openMenu,
                          }
                        )}`}
                        selected={getMenuItemActive("whatsapplogs", false)}
                        onClick={() => {
                        
                          handleDrawerOnMenuSelect(false);
                        }}
                        to="/whatsapplogs"
                      >
                        <div className="d-flex">
                          <ListItemText className={classes.listItemText}>
                            WhatsApp Outbound Logs
                          </ListItemText>
                        </div>
                      </ListItem>}
                </div>
              </Collapse>
            )}
          </>
        )}

        {/* Campaigns */}
        {!helpers.isAgent() && 
          helpers.isFeatureEnabledProfile('is_obd_allowed') && 
          !helpers.isFeatureEnabledProfile('is_suspended_account') &&
          helpers.isUIParamsAvailable('campaign') && !helpers.isFeatureEnabledProfile('hide_iframe_redirection') && !isMobileView && (
            <>
              <ListItem
                component={Link}
                className={`${classes.noHighLightParentMenu} ${clsx(
                  classes.menu,
                  {
                    "justify-content-center flex-grow-1": !openMenu,
                    "text-left": openMenu,
                    "justify-content-start": openMenu
                  }
                )} `}
                selected={
                  getMenuItemActive("/campaign", false) ||
                  getMenuItemActive("/createcampaign", false)
                }
                
                onClick={(e) => {
                  handleMenuExpandCollapseCampaign(e);
                }}
                
                title={""}
                
              >
                <div
                  className={`d-flex align-items-center justify-content-center ${classes.menuLabel} flex-grow-1`}
                >
                  <SVG src={toAbsoluteUrl("/media/sr/icons/campaign-icon-1.svg")} />
                  <div className="d-flex justify-content-between flex-grow-1">
                  <ListItemText className={`${classes.listItemText}`}>
                    Campaign
                  </ListItemText>
                    {openMenu && (
                      <div>
                        {isMenuExpandedCampaign ? <ExpandMore /> : <NavigateNext />}
                      </div>
                    )}
                  </div>
                </div>
              </ListItem>

              {openMenu && (
                <Collapse in={isMenuExpandedCampaign} timeout="auto" unmountOnExit>
                  <div className="ml-10">

                    <ListItem
                      component={Link}
                      className={`${classes.highLightChildMenu} ${clsx(
                        classes.menu,
                        {
                          "justify-content-center": !openMenu,
                          "justify-content-start": openMenu
                        }
                      )}`}
                      selected={getMenuItemActive("/createcampaign", false)}
                      onClick={() => {
                        clearFilters();
                        handleDrawerOnMenuSelect(false);
                      }}
                      to="/createcampaign"
                      
                    >
                      <div>
                        <ListItemText className={classes.listItemText}>
                          Create Campaign
                        </ListItemText>
                      </div>
                    </ListItem>

                    <ListItem
                      component={Link}
                      className={`${classes.highLightChildMenu} ${clsx(
                        classes.menu,
                        {
                          "justify-content-center": !openMenu,
                          "justify-content-start": openMenu
                        }
                      )}`}
                      onClick={() => {
                        clearFilters();
                        handleDrawerOnMenuSelect(false);
                      }}
                      selected={getMenuItemActive("/campaign", false)}
                      to="/campaign"
                    >
                      <div>
                        <ListItemText className={classes.listItemText}>
                          Campaign
                        </ListItemText>
                      </div>
                    </ListItem>

                  </div>
                </Collapse>
              )}
            </>
          )}

        {/* CRM */}
        {helpers.isFeatureEnabled("customer_management") && !helpers.isFeatureEnabledProfile('is_suspended_account') && (
          <ListItem
            component={Link}
            className={`${classes.highLightSingleMenu} ${clsx(classes.menu, {
              "justify-content-center": !openMenu,
              "justify-content-start": openMenu
            })}`}
            selected={getMenuItemActive("/customer-management", false)}
            onClick={() => {
              Tracker.event(
                crmConstants.ANALYTICS.VIEW[0],
                crmConstants.ANALYTICS.VIEW[1],
                crmConstants.ANALYTICS.VIEW[2],
                crmConstants.ANALYTICS.VIEW[3],
                helpers.getUser()
              );
              resetCRM(authRedux, dispatch, false, "");
              handleDrawerOnMenuSelect(false);
            }}
            to="/customer-management"
          >
            <div
              className={`d-flex align-items-center justify-content-center ${classes.menuLabel} `}
            >
              <SVG src={toAbsoluteUrl("/media/sr/icons/customers-icon.svg")} />
              <ListItemText
                style={{ whiteSpace: "pre-line", textAlign: "center" }}
                className={classes.listItemText}
              >
                Customer Management
              </ListItemText>
            </div>
          </ListItem>
        )}

        {/* Configurations */}
        {!helpers.isAgent() &&
          extra_data &&
          extra_data.configurations &&
          extra_data.configurations.is_configuration_enabled && (
            <>
              <ListItem
                component={Link}
                className={`${classes.noHighLightParentMenu} ${clsx(
                  classes.menu,
                  {
                    "justify-content-center flex-grow-1": !openMenu,
                    "text-left": openMenu,
                    "justify-content-start": openMenu
                  }
                )}`}
                onClick={(e) => handleConfigMenuExpandCollapse(e)}
                selected={
                  getMenuItemActive("/phonebooks", false) ||
                  getMenuItemActive("/dispositions", false) ||
                  getMenuItemActive("/templates", false) ||
                  getMenuItemActive("/reports", false) ||
                  getMenuItemActive("/sticky-agent", false) ||
                  getMenuItemActive("/sounds", false)
                }
              >
                <div
                  className={`d-flex align-items-center justify-content-center ${classes.menuLabel} flex-grow-1`}
                >
                  <SVG
                    src={toAbsoluteUrl("/media/sr/icons/configuration.svg")}
                  />
                  <div className="d-flex justify-content-between flex-grow-1">
                    <ListItemText className={classes.listItemText}>
                      Configurations
                    </ListItemText>
                    {openMenu && (
                      <div>
                        {expandConfigMenu ? <ExpandMore /> : <NavigateNext />}
                      </div>
                    )}
                  </div>
                </div>
              </ListItem>

              {openMenu && (
                <Collapse in={expandConfigMenu} timeout="auto" unmountOnExit>
                  <div className="ml-10">
                    {helpers.isFeatureEnabled("is_phonebook_tab_enabled") && 
                    !helpers.isFeatureEnabledProfile('is_suspended_account') && (
                      <ListItem
                        component={Link}
                        className={`${classes.highLightChildMenu} ${clsx(
                          classes.menu,
                          {
                            "justify-content-center": !openMenu,
                            "justify-content-start": openMenu
                          }
                        )}`}
                        selected={getMenuItemActive("phonebooks", false)}
                       
                        onClick={(e) => {
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                        }}
                        title={""}
                        to="/phonebooks"
                      >
                        <div>
                          <ListItemText className={`${classes.listItemText}`}>
                            Phonebooks
                          </ListItemText>
                        </div>
                      </ListItem>
                    )}

                    {helpers.is_disposition_enabled() &&
                    helpers.isFeatureEnabledProfile('is_disposition_enabled') &&
                      helpers.isFeatureEnabled(
                        "is_disposition_tab_enabled"
                      ) && (
                        <ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                              "justify-content-start": openMenu
                            }
                          )}`}
                          selected={getMenuItemActive("dispositions", false)}
                          onClick={() => {
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/dispositions"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              Dispositions
                            </ListItemText>
                          </div>
                        </ListItem>
                      )}

                    {!helpers.isAgent() && 
                      helpers.isFeatureEnabled("is_sound_tab_enabled") && (
                      <ListItem
                        component={Link}
                        className={`${classes.highLightChildMenu} ${clsx(
                          classes.menu,
                          {
                            "justify-content-center": !openMenu,
                            "justify-content-start": openMenu
                          }
                        )}`}
                        selected={getMenuItemActive("sounds", false)}
                        onClick={() => {
                          clearFilters();
                          handleDrawerOnMenuSelect(false);
                        }}
                        to="/sounds"
                      >
                        <div>
                          <ListItemText
                            className={clsx({
                              "ml-6": openMenu,
                            })}
                          >
                            Sounds
                          </ListItemText>
                        </div>
                      </ListItem>
                    )}

                    {!helpers.isAgent() && 
                      helpers.isFeatureEnabled("is_reports_enabled") && (
                      <ListItem
                        component={Link}
                        className={`${classes.highLightChildMenu} ${clsx(
                          classes.menu,
                          {
                            "justify-content-center": !openMenu,
                            "justify-content-start": openMenu
                          }
                        )}`}
                        selected={getMenuItemActive("reports", false)}
                        onClick={() => {
                          clearFilters();
                          handleDrawerOnMenuSelect(false);
                        }}
                        to="/reports"
                      >
                        <div>
                          <ListItemText className={classes.listItemText}>
                            Reports
                          </ListItemText>
                        </div>
                      </ListItem>
                    )}

                    {!helpers.isAgent() &&
                      helpers.isFeatureEnabled("is_template_enabled") && (
                        <ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                              "justify-content-start": openMenu
                            }
                          )}`}
                          selected={getMenuItemActive("templates", false)}
                          onClick={() => {
                            Tracker.event(
                              "Tempaltes",
                              "Click",
                              "Tempaltes Click",
                              "Tempaltes Click Left Nav",
                              helpers.getUser()
                            );
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/templates"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              Templates
                            </ListItemText>
                          </div>
                        </ListItem>
                      )}

                    {(helpers.isCallCenterEnabled() && !helpers.isAgent()) &&
                      helpers.isFeatureEnabled("is_stickynote_tab_enabled") && (
                        <ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                              "justify-content-start": openMenu
                            }
                          )}`}
                          selected={getMenuItemActive("stikcy-agent", false)}
                          onClick={() => {
                            Tracker.event(
                              "Sticky Agent",
                              "Click",
                              "Sticky Agent Click",
                              "Sticky Agent Click Left Nav",
                              helpers.getUser()
                            );
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/sticky-agent"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              Sticky Agents
                            </ListItemText>
                          </div>
                        </ListItem>
                      )}
                  </div>
                </Collapse>
              )}
            </>
          )}

        {/* Settings */}
        {!helpers.isAgent() && (helpers.isFeatureEnabled("is_hook_api_enabled") || helpers.isFeatureEnabled('is_agent_setting_enabled')) && (
          <>
            <ListItem
              component={Link}
              className={`${classes.noHighLightParentMenu} ${clsx(
                classes.menu,
                {
                  "justify-content-center flex-grow-1": !openMenu,
                  "text-left": openMenu,
                  "justify-content-start": openMenu
                }
              )}`}
              onClick={(e) => handleSettingMenuExpandCollapse(e)}
              selected={getMenuItemActive("/settings/", false)}
            >
              <div
                className={`d-flex align-items-center justify-content-center ${classes.menuLabel} flex-grow-1`}
              >
                <SVG src={toAbsoluteUrl("/media/sr/icons/Page Settings.svg")} />

                <div className="d-flex justify-content-between flex-grow-1">
                  <ListItemText className={classes.listItemText}>
                    Settings
                  </ListItemText>
                  {openMenu && (
                    <div>
                      {expandSettingMenu ? <ExpandMore /> : <NavigateNext />}
                    </div>
                  )}
                </div>
              </div>
            </ListItem>

            {openMenu && (
              <Collapse in={expandSettingMenu} timeout="auto" unmountOnExit>
                <div className="ml-10">
                  {helpers.isFeatureEnabled("is_hook_api_enabled") && helpers.isFeatureEnabledProfile('hookapi_enabled') && (
                    <ListItem
                      component={Link}
                      className={`${classes.highLightChildMenu} ${clsx(
                        classes.menu,
                        {
                          "justify-content-center": !openMenu,
                          "justify-content-start": openMenu
                        }
                      )}`}
                      selected={getMenuItemActive("hookapi", false)}
                      onClick={() => {
                        Tracker.event(
                          "Hook API",
                          "Click",
                          "Hook API Click Left Nav Bar",
                          "",
                          helpers.getUser()
                        );
                        clearFilters();
                        handleDrawerOnMenuSelect(false);
                      }}
                      to="/hookapi"
                    >
                      <div>
                        <ListItemText className={classes.listItemText}>
                          Hook API
                        </ListItemText>
                      </div>
                    </ListItem>
                  )}
                  {helpers.isFeatureEnabled('is_agent_setting_enabled') && (
                  <ListItem
                    component={Link}
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.menu,
                      {
                        "justify-content-center": !openMenu,
                        "justify-content-start": openMenu
                      }
                    )}`}
                    selected={getMenuItemActive("agentsettings", false)}
                    onClick={() => {
                      clearFilters();
                      handleDrawerOnMenuSelect(false);
                    }}
                    to="/agentsettings"
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        Agent Settings
                      </ListItemText>
                    </div>
                  </ListItem>
                  )}

                  { helpers.isCallCenterEnabled() && (
                    <ListItem
                      component={Link}
                      className={`${classes.highLightChildMenu} ${clsx(
                        classes.menu,
                        {
                          "justify-content-center": !openMenu,
                        }
                      )}`}
                      selected={getMenuItemActive("queueSettings", false)}
                      onClick={() => {
                        clearFilters();
                        handleDrawerOnMenuSelect(false);
                      }}
                      to="/queueSettings"
                    >
                      <div>
                        <ListItemText className={classes.listItemText}>
                          Queue Settings
                        </ListItemText>
                      </div>
                    </ListItem>
                  )}

                  {!helpers.isFeatureEnabledProfile('hide_iframe_redirection') && !isMobileView &&
                    <>
                      {!helpers.isCPSettingsAvailable('settings_call_flow') &&
                        <ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                              "justify-content-start": openMenu
                            }
                          )}`}
                          selected={getMenuItemActive("callflow", false)}
                          onClick={() => {
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/callflow"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              Call Flow
                            </ListItemText>
                          </div>
                        </ListItem>}

                      {(!helpers.isCPSettingsAvailable('settings_sms_flow') &&
                        helpers.isUIParamsAvailable('smsflow') &&
                        helpers.isFeatureEnabledProfile("is_sms_enabled")) &&
                        <ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                              "justify-content-start": openMenu
                            }
                          )}`}
                          selected={getMenuItemActive("smsflow", false)}
                          onClick={() => {
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/smsflow"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              SMS Flow
                            </ListItemText>
                          </div>
                        </ListItem>}

                      {/* {helpers.isCallCenterEnabled() && (
                        <ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                              "justify-content-start": openMenu
                            }
                          )}`}
                          selected={getMenuItemActive("callgroups", false)}
                          onClick={() => {
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/callgroups"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              Call Groups
                            </ListItemText>
                          </div>
                        </ListItem>)} */}

                      {helpers.isUIParamsAvailable('integrations') &&
                        (!helpers.isSuperVisor() ||
                          (!helpers.isFeatureEnabledProfile('disable_supervisors_access_integrations') &&
                            !helpers.isCPSettingsAvailable('settings_integrations'))) &&
                        <ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                              "justify-content-start": openMenu
                            }
                          )}`}
                          selected={getMenuItemActive("integrations", false)}
                          onClick={() => {
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/integrations"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              Integrations
                            </ListItemText>
                          </div>
                        </ListItem>}
                    </>
                  }

                </div>
              </Collapse>
            )}
          </>
        )}

        {/* Account */}
        {(helpers.isAdmin() && helpers.isUIParamsAvailable('account')) && !helpers.isFeatureEnabledProfile('hide_iframe_redirection') && !isMobileView && (
          <>
            <ListItem
              component={Link}
              className={`${classes.noHighLightParentMenu} ${clsx(
                classes.accMenu,
                {
                  "justify-content-center flex-grow-1": !openMenu,
                  "text-left": openMenu,
                  "justify-content-start": openMenu
                }
              )}`}
              selected={
                getMenuItemActive("/settings", false) ||
                (helpers.isFeatureEnabledProfile('international_user') && getMenuItemActive("/account_profile", false)) ||
                getMenuItemActive("/invoices", false) ||
                getMenuItemActive("/billing_summary", false) ||
                getMenuItemActive("/history", false) ||
                getMenuItemActive("/payments", false) ||
                getMenuItemActive("/billstatement", false)
              }
              onClick={(e) => handleMenuExpandCollapseAccount(e)}
            >
              <div
                className={`d-flex align-items-center justify-content-center ${classes.menuLabel} flex-grow-1`}
              >
                <SVG src={toAbsoluteUrl("/media/sr/icons/campaign-icon-1.svg")} />
                <div className="d-flex justify-content-between flex-grow-1">
                  <ListItemText className={classes.listItemText}>
                    Account
                  </ListItemText>
                  {openMenu && (
                    <div>
                      {isMenuExpandedAccount ? <ExpandMore /> : <NavigateNext />}
                    </div>
                  )}
                </div>
              </div>
            </ListItem>

            {openMenu && (
              <Collapse in={isMenuExpandedAccount} timeout="auto" unmountOnExit>
                <div className="ml-10">

                  {helpers.isAccountSettingsEnabled() &&
                  <ListItem
                    component={Link}
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.accMenu,
                      {
                        "justify-content-center": !openMenu,
                        "justify-content-start": openMenu
                      }
                    )}`}
                    selected={getMenuItemActive("settings", false)}
                    onClick={() => {
                      clearFilters();
                      handleDrawerOnMenuSelect(false);
                    }}
                    to="/settings"
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        Settings
                      </ListItemText>
                    </div>
                  </ListItem>}

                  {helpers.isFeatureEnabledProfile('international_user') &&
                  <ListItem
                  component={Link}
                  className={`${classes.highLightChildMenu} ${clsx(
                    classes.accMenu,
                    {
                      "justify-content-center": !openMenu,
                      "justify-content-start": openMenu
                    }
                  )}`}
                  selected={getMenuItemActive("account_profile", false)}
                  onClick={() => {
                    clearFilters();
                    handleDrawerOnMenuSelect(false);
                  }}
                  to="/account_profile"
                >
                  <div>
                    <ListItemText className={classes.listItemText}>
                      Profile
                    </ListItemText>
                  </div>
                  </ListItem>}

                  {helpers.isAccountInvoicesEnabled() && 
                  <ListItem
                    component={Link}
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.accMenu,
                      {
                        "justify-content-center": !openMenu,
                        "justify-content-start": openMenu
                      }
                    )}`}
                    onClick={() => {
                      clearFilters();
                      handleDrawerOnMenuSelect(false);
                    }}
                    selected={getMenuItemActive("invoices", false)}
                    to="/invoices"
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        Invoices
                      </ListItemText>
                    </div>
                  </ListItem>}

                  {helpers.isAccountBillingSummaryEnabled() &&
                  <ListItem
                    component={Link}
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.accMenu,
                      {
                        "justify-content-center": !openMenu,
                        "justify-content-start": openMenu
                      }
                    )}`}
                    onClick={() => {
                      clearFilters();
                      handleDrawerOnMenuSelect(false);
                    }}
                    selected={getMenuItemActive("billing_summary", false)}
                    to="/billing_summary"
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        Billing Summary
                      </ListItemText>
                    </div>
                  </ListItem>}

                  {helpers.isAccountHistoryEnabled() &&
                  <ListItem
                    component={Link}
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.accMenu,
                      {
                        "justify-content-center": !openMenu,
                        "justify-content-start": openMenu
                      }
                    )}`}
                    onClick={() => {
                      clearFilters();
                      handleDrawerOnMenuSelect(false);
                    }}
                    selected={getMenuItemActive("history", false)}
                    to="/history"
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        History
                      </ListItemText>
                    </div>
                  </ListItem>}

                  {helpers.isPaymentsTabEnabled() && helpers.isAdmin() && 
                  <ListItem
                    component={Link}
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.accMenu,
                      {
                        "justify-content-center": !openMenu,
                        "justify-content-start": openMenu
                      }
                    )}`}
                    onClick={() => {
                      clearFilters();
                      handleDrawerOnMenuSelect(false);
                    }}
                    selected={getMenuItemActive("payments", false)}
                    to="/payments"
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        Payments & Plans
                      </ListItemText>
                    </div>
                  </ListItem>}

                  {/* <ListItem
                    component={Link}
                    className={`${classes.highLightChildMenu} ${clsx(
                      classes.menu,
                      {
                        "justify-content-center": !openMenu,
                      }
                    )}`}
                    onClick={() => {
                      clearFilters();
                      handleDrawerOnMenuSelect(false);
                    }}
                    selected={getMenuItemActive("billstatement", false)}
                    to="/billstatement"
                  >
                    <div>
                      <ListItemText className={classes.listItemText}>
                        Bill Statement
                      </ListItemText>
                    </div>
                  </ListItem> */}

                </div>
              </Collapse>
            )}
          </>
        )}

        {/* Hierarchy */}
        {/* {helpers.isHierarchyEnabledAccount() &&
          <ListItem
            // target="_blank"
            button
            component="a"
            className={`${classes.highLightChildMenu} ${clsx(
              classes.menu,
              {
                "justify-content-center": !openMenu,
              }
            )}`}
            onClick={() => {
              Tracker.event(
                "Hierarcy",
                "Click",
                "Hierarcy Click",
                "Hierarcy Click Left Nav",
                helpers.getUser()
              );
              clearFilters();
              handleDrawerOnMenuSelect(false);
            }}
            href={process.env.REACT_APP_IFRAME_BASE_URL + 'hierarchy/insights'}
          >
            <div className={`d-flex align-items-center justify-content-center ${classes.menuLabel} `}>
              <SVG src={toAbsoluteUrl("/media/sr/icons/insights-icon.svg")} />
              <ListItemText className={classes.listItemText}>
                Hierarcy
              </ListItemText>
            </div>
          </ListItem>
        } */}

        {/* Developer Documentation */}
        {!helpers.isAgent() && !helpers.isFeatureEnabledProfile('is_suspended_account') && (
          <>
            <ListItem
              component={Link}
              className={`${classes.noHighLightParentMenu} ${clsx(
                classes.menu,
                {
                  "justify-content-center flex-grow-1": !openMenu,
                  "text-left": openMenu,
                }
              )}`}
              selected={
                getMenuItemActive("/api-documentation", false) ||
                getMenuItemActive("/developerdocs", false)
              }
              onClick={(e) => handleDeveloperMenuExpandCollapse(e)}
              // selected={getMenuItemActive("/developer/", false)}
            >
              <div
                className={`d-flex align-items-center justify-content-center ${classes.menuLabel} flex-grow-1`}
              >
                <SVG src={toAbsoluteUrl("/media/sr/icons/Page Settings.svg")} />

                <div className="d-flex justify-content-between flex-grow-1">
                  <ListItemText className={classes.listItemText}>
                    Developer Docs
                  </ListItemText>
                  {openMenu && (
                    <div>
                      {expandDeveloperMenu ? <ExpandMore /> : <NavigateNext />}
                    </div>
                  )}
                </div>
              </div>
            </ListItem>

            {openMenu && (
              <Collapse in={expandDeveloperMenu} timeout="auto" unmountOnExit>
                <div className="ml-10">
                  {!helpers.isFeatureEnabledProfile('hide_iframe_redirection') &&
                    <>
                      {(<ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                            }
                          )}`}
                          selected={getMenuItemActive("developerdocs", false)}
                          onClick={() => {
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/developerdocs"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              X-API Key
                            </ListItemText>
                          </div>
                        </ListItem>)}

                        {(<ListItem
                          component={Link}
                          className={`${classes.highLightChildMenu} ${clsx(
                            classes.menu,
                            {
                              "justify-content-center": !openMenu,
                            }
                          )}`}
                          selected={getMenuItemActive("api-documentation", false)}
                          onClick={() => {
                            clearFilters();
                            handleDrawerOnMenuSelect(false);
                          }}
                          to="/api-documentation"
                        >
                          <div>
                            <ListItemText className={classes.listItemText}>
                              API Documentation
                            </ListItemText>
                          </div>
                        </ListItem>)}
                    </>
                  }

                </div>
              </Collapse>
            )}
          </>
        )}

      </List>
    </div>
  );

  return (
    <div>
      <ThemeProvider theme={theme}>
      <ConfigurationToastMessage
        severity={statusToastInfo.severity}
        snackbarMessage={statusToastInfo.snackbarMessage}
        open={statusToastInfo.open}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      {isMobileView ? (
        <SwipeableDrawer
          style={{ zIndex: 1100 }}
          elevation={1}
          variant="temporary"
          disableDiscovery
          disableBackdropTransition
          disableSwipeToOpen
          disableAutoFocus
          disableBackdropClick
          anchor="left"
          open={openMenu}
          ModalProps={{
            keepMounted: true,
          }}
          {...swipeableDrawerProps}
        >
          <div className="d-block d-lg-none">
            <div className="d-flex align-items-center flex-column mt-7 mb-4">
              <UserProfileImageWithStatus />
            </div>

            <div className="mob-user-name">
              <TextWrap
                text={`${user.first_name} ${user.last_name}`}
                max={30}
              />
            </div>
            <div className="mob-user-email mt-2">
              {" "}
              <TextWrap text={user?.email} max={35} />
            </div>
            {helpers.isCallCenterEnabled() && (
              <div
                className="d-flex align-items-center justify-content-center mt-3 "
                style={{ fontSize: "14px" }}
              >
                <div
                  style={{
                    background: "white",
                    padding: "4px 8px",
                    paddingLeft: "16px",
                    borderRadius: "10px",
                  }}
                >
                  <UserStatusDropdown />
                </div>
              </div>
            )}
            <Loader2 resource="update_userStatus" />

            <div className="mobile-menu-setting-opts hide">
              {helpers.isAgent() ? (
                <>
                  <span className="mobile-menu-search-icon">
                    <img
                      alt="logo"
                      src={toAbsoluteUrl("/media/sr/icons/search-icon.svg")}
                    />
                  </span>
                  <span>
                    <img
                      alt="logo"
                      src={toAbsoluteUrl("/media/sr/icons/header-settings.svg")}
                    />
                  </span>
                </>
              ) : (
                <span className="">
                  <img
                    alt="logo"
                    src={toAbsoluteUrl("/media/sr/icons/search-icon.svg")}
                  />
                </span>
              )}
            </div>
            <div className="mobile-menu-setting-opts">
              <span className="mob-phone-select">
                <PhoneSelect />
              </span>
            </div>
            <div></div>
            <div className="mobile-detail-separator hide1"></div>
          </div>

          <div className="mt-8 mb-6">{renderMenus()}</div>

          {true && (
            <div className="menu-logout d-block d-lg-none">
              <Link
                className="btn btn-block font-weight-bold mb-btn-logout"
                onClick={(e) => {
                  e.preventDefault();
                  handleUserStatus();
                }}
              >
                <ExitToAppIcon /> Logout
              </Link>
            </div>
          )}
        </SwipeableDrawer>
      ) : (
        <SwipeableDrawer
          elevation={1}
          variant="permanent"
          disableSwipeToOpen
          open={false}
          {...swipeableDrawerProps}
        >
          {renderMenus()}
          <div className="menu-logout d-block d-lg-none">
            <Link
                onClick={(e) => {
                  e.preventDefault();
                  handleUserStatus();
                }}
              className="btn btn-block font-weight-bold mb-btn-logout"
            >
              <ExitToAppIcon /> Logout
            </Link>
          </div>
        </SwipeableDrawer>
      )}
      </ThemeProvider>
    </div>
  );
};

export default AsideMenu;
